<!-- Navbar -->
<div class="relative bg-blueGray-100 md:pt-8 pb-8">
  <div class="px-4 mx-auto w-full">
    <nav
      class="absolute top-0 left-0 w-full bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4">

      <div class="w-full mx-auto items-center flex justify-end md:flex-nowrap flex-wrap px-4">

        <!-- Brand -->
        <!-- <a class="text-primary-200 text-sm hidden lg:inline-block font-semibold">{{ currentRoute }}</a> -->

        <!-- <h2 class="text-primary-500 uppercase font-bold text-lg">My Communities</h2> -->

        <!-- Form -->
        <!-- <form class="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
      <div class="relative flex w-full flex-wrap items-stretch">
        <span
          class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"><i
            class="fas fa-search"></i></span>
        <input type="text" placeholder="Search here..."
          class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10" />
      </div>
    </form> -->

        <!-- User -->
        <ul class="flex-col md:flex-row list-none items-center hidden md:flex ml-auto">
          <app-user-dropdown class="block"></app-user-dropdown>
        </ul>
      </div>
    </nav>
  </div>
</div>